import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import classNames from "classnames";
import * as React from "react";
import { useIntl } from "react-intl";
import { NavLink as NavLinkRouter } from "react-router-dom";
import { NavLink } from "..";
import { allTypesUrl } from "../../app/routes";
import arrowIcon from "../../images/left.svg";

var NavItem = function NavItem(_ref) {
  var hideOverlay = _ref.hideOverlay,
      showSubItems = _ref.showSubItems,
      allTypesImage = _ref.allTypesImage,
      imageUrl = _ref.imageUrl,
      item = _objectWithoutProperties(_ref, ["hideOverlay", "showSubItems", "allTypesImage", "imageUrl"]);

  var hasSubNavigation = item.children && !!item.children.length;
  var intl = useIntl();
  return React.createElement("li", {
    className: classNames({
      "side-nav__menu-item": true,
      "side-nav__menu-item--has-subnavigation": hasSubNavigation
    })
  }, React.createElement("img", {
    src: arrowIcon,
    alt: "arrow icon",
    className: "side-nav__menu-item-link-icon"
  }), React.createElement(NavLink, {
    item: item,
    className: "side-nav__menu-item-link",
    onClick: hideOverlay
  }, imageUrl && React.createElement("div", {
    className: "side-nav__menu-item-image",
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  }), React.createElement("span", {
    className: "side-nav__menu-item-title"
  }, item.name)), hasSubNavigation && React.createElement(React.Fragment, null, item.children && React.createElement("div", {
    className: "side-nav__menu-item-parent"
  }, React.createElement(NavLinkRouter, {
    exact: true,
    to: allTypesUrl,
    className: "side-nav__menu-item-link",
    onClick: hideOverlay
  }, allTypesImage && React.createElement("div", {
    className: "side-nav__menu-item-image",
    style: {
      backgroundImage: "url(".concat(allTypesImage.url, ")")
    }
  }), React.createElement("span", {
    className: "side-nav__menu-item-title"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "all types",
    "id": "components.MobileNav.NavItem.156713073"
  }, "id", "components.MobileNav.NavItem.156713073")))), item.children.map(function (child, i) {
    var _child$category$backg;

    return React.createElement(NavLink, {
      item: child,
      className: "side-nav__menu-item-link",
      onClick: hideOverlay,
      key: i
    }, imageUrl && React.createElement("div", {
      className: "side-nav__menu-item-image",
      style: {
        backgroundImage: "url(".concat((_child$category$backg = child.category.backgroundImage) === null || _child$category$backg === void 0 ? void 0 : _child$category$backg.url, ")")
      }
    }), React.createElement("span", {
      className: "side-nav__menu-item-title"
    }, child.name));
  }))));
};

export default NavItem;